import React from 'react';
import Article from './Article';

const ArticleList = (props) => {
        const {searchResults, heightForVirtualization, end} = props;

        return (
            <>
                <div className="home-page-article-list">
                    <div style={{heightForVirtualization}}>
                        <div>
                            {searchResults && searchResults.slice(0, end).map(item =>
                                <Article article={item} key={item.type ? `${item.type}-${item.id}` :
                                    item.sourceType ? `${item.type}-${item.id}` : item.id}/>,
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
;

export default ArticleList;